var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterAlign(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    width: 54.6875,
    height: 50,
    rx: 4,
    fill: "#F5DAF7",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.1667H16C15.2444 16.1667 14.6667 15.5889 14.6667 14.8333C14.6667 14.0778 15.2444 13.5 16 13.5H40C40.7555 13.5 41.3333 14.0778 41.3333 14.8333C41.3333 15.5889 40.7555 16.1667 40 16.1667Z",
    fill: "#99439D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23.278H20C19.2444 23.278 18.6667 22.7002 18.6667 21.9447C18.6667 21.1891 19.2444 20.6113 20 20.6113H36C36.7555 20.6113 37.3333 21.1891 37.3333 21.9447C37.3333 22.7002 36.7555 23.278 36 23.278Z",
    fill: "#99439D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.3893H16C15.2444 30.3893 14.6667 29.8115 14.6667 29.056C14.6667 28.3004 15.2444 27.7227 16 27.7227H40C40.7555 27.7227 41.3333 28.3004 41.3333 29.056C41.3333 29.8115 40.7555 30.3893 40 30.3893Z",
    fill: "#99439D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37.4997H20C19.2444 37.4997 18.6667 36.9219 18.6667 36.1663C18.6667 35.4108 19.2444 34.833 20 34.833H36C36.7555 34.833 37.3333 35.4108 37.3333 36.1663C37.3333 36.9219 36.7555 37.4997 36 37.4997Z",
    fill: "#99439D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlign);
export default __webpack_public_path__ + "static/media/center-align.4fb8a4c11e37b5089435167cfacc1887.svg";
export { ForwardRef as ReactComponent };